<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Historical Data
          </h5>
          <b-button
            v-if="details == 1"
            @click="detailView"
            class="btn-outline ml-3"
            variant="outline-primary"
            right
          >
            Back
          </b-button>
          <div class="card-header-actions">
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i
                class="fa fa-file-pdf-o"
                style="color: rgb(32, 168, 216);"
                aria-hidden="true"
              ></i>
            </b-button>
          </div>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <h5>Quantity</h5>
          <c-switch
            class="mx-1"
            color="primary"
            v-model="valueQuantity"
            value="true"
            uncheckedValue="false"
            variant="pill"
          />
          <h5>Financials</h5>
        </div>
        <div class="chart-wrapper">
          <div
            style="height: 400px; padding-top: 150px"
            v-if="loadingData"
            class="loading"
          >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <b-form-checkbox
            id="checkbox-historical"
            class="mx-1"
            v-model="toggleData"
            name="checkbox-historical"
            value="true"
            unchecked-value="false"
            >Show / Hide All</b-form-checkbox
          >
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";

export default {
  name: "HistoricalData-Stacked",
  components: {
    router,
    highcharts: Chart,
    cSwitch
    //Datapicker
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity", "details"],
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      showAll: false,
      totalValue: null,
      modalDate: false,
      valueQuantity: false,
      toggleData: false,
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {
        tooltip: {
          formatter: function() {
            return;
          }
        },
        chart: {
          type: "column",
          backgroundColor: "transparent"
        },
        exporting: {
          enabled: true
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: "none"
          }
        },
        legend: {
          itemStyle: {
            color: "white"
          }
        },
        xAxis: {
          categories: [],
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total repair by Year"
          },
          labels: {
            style: {
              color: "white"
            }
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color: "white"
            }
          }
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              formatter: function() {
                return "TEST";
              }
            },
            events: {
              legendItemClick: data => {
                this.totalValue = null;
              }
            }
          }
        },
        series: []
      }
    };
  },

  watch: {
    totalValue(value) {
      var chartSeries = this.$refs.backRef.chart.series;
      var pointSum = 0;
      chartSeries.forEach(function(obj) {
        if (obj.visible == true) {
          obj.yData.forEach(function(datas) {
            pointSum += datas;
          });
        }
      });
      this.totalValue = pointSum;
      if (!this.valueQuantity || this.valueQuantity == "false") {
        this.chartOptions.title.text = "Total units: " + this.totalValue;
      } else {
        this.chartOptions.title.text =
          "Total: " +
          "$" +
          this.totalValue
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
    },
    fullscreen(value) {
      if (value == false) {
        this.$emit("detailViewHistorical");
      }
    },
    valueQuantity(value) {
      this.fetchData();
      if (this.fullScreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
    },
    toggleData(param) {
      var chartSeries = this.$refs.backRef.chart.series;
      console.log(param);
      chartSeries.forEach(obj => {
        if (param === "false") {
          obj.show();
        } else {
          obj.hide();
        }
      });
    }
  },

  methods: {
    detailView() {
      this.$emit("detailViewHistorical");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      let params = {};
      params = {
        type: finType
      };
      this.$http
        .get("api/fns/charts/historicalByProdGroup.php", {
          params
        })
        .then(
          res => {
            let myArray = res.data;
            let xAxis = [];
            var datum = [];

            var fiber = {
              name: "Fiber Gear",
              data: [],
              color: "rgb(124, 181, 236)"
            };
            var power = {
              name: "Power Supply",
              data: [],
              color: "rgb(247, 163, 92)"
            };
            var line = {
              name: "Line Gear",
              data: [],
              color: "rgb(144, 237, 125)"
            };
            var meter = {
              name: "Meter",
              data: [],
              color: "rgb(145, 232, 225)"
            };
            var transponder = {
              name: "Transponder",
              data: [],
              color: "rgb(241, 92, 128)"
            };
            var headend = {
              name: "Headend",
              data: [],
              color: "rgb(43, 144, 143)"
            };
            var wireless = {
              name: "Wireless",
              data: [],
              color: "rgb(23, 114, 143)"
            };

            for (var type in myArray) {
              datum.push([type, myArray[type]]);
            }
            datum.forEach(obj => {
              xAxis.push(obj[0]);
              Object.entries(obj[1]).forEach(([key, value]) => {
                var tempValue = parseInt(value);

                switch (key) {
                  case "Fiber Gear":
                    fiber.data.push(tempValue);

                    break;
                  case "Power Supply":
                    power.data.push(tempValue);

                    break;
                  case "Line Gear":
                    line.data.push(tempValue);

                    break;
                  case "Meter":
                    meter.data.push(tempValue);

                    break;
                  case "Transponder":
                    transponder.data.push(tempValue);
                    break;
                  case "Headend":
                    headend.data.push(tempValue);
                    break;
                  case "Wireless":
                    wireless.data.push(tempValue);
                    break;
                }
              });
            });

            this.chartOptions.xAxis.categories = xAxis;
            this.chartOptions.series[0] = fiber;
            this.chartOptions.series[1] = power;
            this.chartOptions.series[2] = line;
            this.chartOptions.series[3] = meter;
            this.chartOptions.series[4] = transponder;
            this.chartOptions.series[5] = headend;
            this.chartOptions.series[6] = wireless;

            // Getting total amount wihtout response
            var seriesData = this.chartOptions.series;
            var pointSum = 0;
            seriesData.forEach(function(point) {
              var datasValue = point.data;
              datasValue.forEach(function(value) {
                pointSum += value;
              });
            });

            this.totalValue = pointSum;
            if (finType == "Fin") {
              this.chartOptions.title.text =
                "Total: " +
                "$" +
                pointSum
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");

              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": $" +
                  this.y
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return (
                  "$" +
                  this.y
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return (
                  "Total: " +
                  "$" +
                  this.total
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.legend.labelFormatter = function() {
                var dataGet = this.yData;
                var summaryData = 0;
                dataGet.forEach(function(point) {
                  summaryData += point;
                });
                return (
                  "<b>" +
                  this.name +
                  '</b> <small style="font-size:0.2em !important"><br>Total: $' +
                  summaryData
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") +
                  "</small>"
                );
              };
            } else {
              this.chartOptions.title.text = "Total units: " + pointSum;

              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": " +
                  this.y +
                  " units"
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return this.y;
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + this.total;
              };

              this.chartOptions.legend.labelFormatter = function() {
                var dataGet = this.yData;
                var summaryData = 0;
                dataGet.forEach(function(point) {
                  summaryData += point;
                });
                return (
                  "<b>" +
                  this.name +
                  "</b> <small><br>Total: " +
                  summaryData +
                  "</small>"
                );
              };
            }

            if (this.details == 1 && this.fullscreen == false) {
              this.toggleFullScreen();
              this.chartOptions.chart.height = "47%";
            }

            this.loadingData = false;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Historical Data | " + this.dateTo;
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Historical Data | " + this.dateTo + " " + this.nameCity;
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.options.yAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "HistoricalData-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
    }
  },
  mounted() {
    if (!localStorage.getItem("fns_user")) {
      router.push("/pages/login/");
    }

    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }

    this.valueQuantity = false;

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
